import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { EcgArrhythmiaSignalResponse } from './type'
import { ECG_ARRHYTHMIA_API_BASE_URL } from '../../constants/apiConstants'

const baseQuery = fetchBaseQuery({
  baseUrl: ECG_ARRHYTHMIA_API_BASE_URL,
})

export const RecordedEcgArrhythmiaSignalsApi = createApi({
  reducerPath: 'recordedEcgArrhythmiaSignals',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getRecordedEcgArrhythmiaSignals: builder.query<
    EcgArrhythmiaSignalResponse,
      { patientKey: string; ecgWindowId: string }
    >({
      query: ({ patientKey, ecgWindowId }) =>
        `api/ecg-signals/${patientKey}/ecg-window/${ecgWindowId}`,
    }),
  }),
})

export const { useLazyGetRecordedEcgArrhythmiaSignalsQuery } = RecordedEcgArrhythmiaSignalsApi
